module.exports = __webpack_public_path__ + "img/collection-weddingRingsRingSets.fe8e27f.jpg";